import Entity from "@mm/state/model/requestModels/Entity";

export default class TriggerEntity extends Entity {
  static make(
    chatbotId,
    sortOrder,
    defaultDialogueId,
    defaultResponse = { responseType: 'Dialogue', pageId: defaultDialogueId },
  ) {
    return {
      ...super.make(),
      sortOrder,
      randomize: false,
      botId: chatbotId,
      phrases: [],
      active: false,
      botResponses: [{ ...defaultResponse, sortOrder: 1 }],
    };
  }
}
